module.exports = __webpack_public_path__ + "media/application/images/bl-logo-6cd68289018a6ce81fc5fa0b4c12b582.svg";